import { useContext, useEffect, useRef, useState } from "react";
import { IImportModel } from "../model/IImportModel";
import { FormProvider, useForm } from "react-hook-form";
import { NewDocumentModalViewContext } from "../../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../../Shared/DocumentModalViewHeader";
import { NFTabs } from "../../../../Shared/NewForms/NFTabs";
import { NFTabContainer } from "../../../../Shared/NewForms/NFTabContainer";
import { NFSecondTab } from "../../../../Shared/NewForms/NFSecondTab";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../../helpers/DocumentHelper";
import ImportsDetailSkeleton from "./ImportsDetailSkeleton";
import { ImportsDetailMain } from "./ImportsDetailMain";
import { ImportsDetailAdditionalDocuments } from "./ImportsDetailAdditionalDocuments";
import { ImportsDetailCustomCosts } from "./ImportsDetailCustomCosts";
import { ImportsDetailExciseDuty } from "./ImportsDetailExciseDuty";
import { ImportsDetailImportTax } from "./ImportsDetailImportTax";
import { AppEntities } from "../../../../../config/entities";
import { importFromExcel } from "../../../../../helpers/SaveObjectToExcel";
import { saveObjectToExcel } from "../../../../../helpers/SaveObjectToExcel";
import { ImportsDetailVats } from "./ImportsDetailVats";
import { ImportsDetailFOoter } from "./ImportsDetailFOoter";
import { ImportDto } from "../dtos/IImportsDto";
import { useFetchImport } from "../hooks/fetchDocument";
import DocumentDetailViewToolbar from "src/components/Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewCancelButton from "src/components/Shared/DetailViewCancelButton";
import DetailViewPostButton from "src/components/Shared/DetailViews/DetailViewPostButton";

interface IProps {
  id?: string;
}

export const ImportsDetail = ({ id }: IProps) => {
  const [tabIndex, setTabIndex] = useState(0);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<IImportModel>({
    mode: "onTouched"
  });
  const { isDocumentLoading, documentModel, postDocument, cancelDocument, updateDocument } = useFetchImport({ documentId: id });

  useEffect(() => {
    if (documentModel) {
      reset(documentModel);
    }
  }, [documentModel]);

  useEffect(() => {
    if (formState.isDirty) {
      console.log("formState.isDirty", formState.isDirty);
      updateDocument(getValues());
    }
  }, [formState.isDirty]);

  const handlePost = async () => {
    await postDocument();
  };

  const handleCancel = async () => {
    await cancelDocument();
  };

  // const [fileName, setFileName] = useState("Imports");
  
  // const exportToExcel = () => {
  //   const data = {
  //     ...model
  //   };
  //   const documentInfo = {
  //     title: AppEntities.ConsumptionOrders.title,
  //     number: model.documentNumber,
  //     date: model.documentDate
  //   };
  //   saveObjectToExcel(data, documentInfo);
  // };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFSecondTab title={"Main"} />
        <NFSecondTab title={"Additional Documents"} />
        <NFSecondTab title={"Custom Cost"} />
        <NFSecondTab title={"Excise Duty"} />
        <NFSecondTab title={"Import Tax"} />
        <NFSecondTab title={"Vats"} />
      </NFTabs>
      <div className={"modal-container-height"}>
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handlePost} />
          <DetailViewCancelButton onCancel={handleCancel} />
          {/*<DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel}*/}
          {/*                              fileName={fileName} setFileName={setFileName}/>*/}
        </DocumentDetailViewToolbar>
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <ImportsDetailMain />
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <ImportsDetailAdditionalDocuments />
        </NFTabContainer>

        <NFTabContainer index={2} currentIndex={tabIndex}>
          <ImportsDetailCustomCosts />
        </NFTabContainer>

        <NFTabContainer index={3} currentIndex={tabIndex}>
          <ImportsDetailExciseDuty />
        </NFTabContainer>

        <NFTabContainer index={4} currentIndex={tabIndex}>
          <ImportsDetailImportTax />
        </NFTabContainer>

        <NFTabContainer index={5} currentIndex={tabIndex}>
          <ImportsDetailVats />
        </NFTabContainer>
      </div>
      <ImportsDetailFOoter />
    </FormProvider>
  );
};
